'use strict';
// write code here
var form = document.querySelector('form');
var inputs = form.querySelectorAll('input');
inputs.forEach(function(input, index) {
    var label = document.createElement('label');
    label.classList.add('field-label');
    label.textContent = input.name;
    if (!input.id) input.id = "input-".concat(index);
    label.setAttribute('for', input.id);
    input.before(label);
    input.placeholder = input.name.charAt(0).toUpperCase() + input.name.slice(1);
});

//# sourceMappingURL=js_task_fix_form_DOM.c266c1ea.js.map
